export const normalizeValue = (value: number, maxValue: number): number =>
    (100 * value) / maxValue;
